// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("./IconV5.bs.js");
let Link = require("next/link").default;
let JsxRuntime = require("react/jsx-runtime");

function Breadcrumbs(props) {
  return JsxRuntime.jsx("nav", {
    children: JsxRuntime.jsx("ol", {
      children: props.pages.map((page, i) => JsxRuntime.jsx("li", {
        children: JsxRuntime.jsxs("div", {
          children: [
            i === 0 ? null : JsxRuntime.jsx(IconV5.make, {
                icon: "arrow-right",
                className: "h-3 w-3 flex-shrink-0 text-zinc-400"
              }),
            JsxRuntime.jsx(Link, {
              href: page.href,
              className: "font-medium text-zinc-500 hover:text-zinc-700",
              children: page.name
            })
          ],
          className: "flex items-center space-x-3"
        })
      }, page.name)),
      className: "flex items-center space-x-3",
      role: "list"
    }),
    "aria-label": "Breadcrumb",
    className: "flex"
  });
}

let make = Breadcrumbs;

exports.make = make;
/* IconV5 Not a pure module */
